import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom/es';
import { Page } from '../../components';
import Box from '../../components/layout/Box';
import Button from '../../components/widgets/Button';
import { actions } from 'redux-notifications';
import { getProfile, getAuthState } from 'signoxe/selectors';

import {
  fetchUsers, addUser, setPageTitle
} from 'signoxe/actions';

import {
  getUsers, isFetching
} from 'signoxe/selectors';

import './styles.scss';

const initialState = {
  sub_user: '',
  username: '',
  email: '',
  password: '',
  password1: '',
  add_default: false
}

const { notifSend } = actions;

class ClientUserCreatePage extends React.Component {

  constructor(props) {
    super(props);

    this.state = initialState;

    // this.state = mainIinitialState
  }




  componentDidMount() {
    this.props.fetchUsers()
    this.props.setPageTitle('Add Client User')

  }

  notify(message) {
    this.props.notifSend({ message, kind: 'alert', dismissAfter: 3000 })
  }

  createUser() {
    const { username, sub_user, email, password, password1 } = this.state;




    if (!sub_user || !email) {
      this.notify('User details incomplete');
    }

    else if (!password || !password1) {
      this.notify('Password incomplete');
    }

    else if (password !== password1) {
      this.notify('Passwords do not match');
    }
    else {

      const allState = {
        username: window.localStorage.getItem('alias') + "." + sub_user,
        email: email,
        password: password,
        password1: password1,
        add_default: false
      }
      this.props.addUser(allState)
      this.setState(initialState)
    }
  }

  render() {
    const { username, sub_user, add_default, email, password, password1 } = this.state;

    return (
      <Page className="user-manage-page cw">
        <h3>Add User</h3>
        <label for='txt'>
          <input type="text" id="subusername" width="15%" value={window.localStorage.getItem('alias') + "."} disabled />
          <input type="text" id='txt' value={sub_user} onChange={(e) => this.setState({ sub_user: e.target.value })} placeholder="Username" />
        </label>
        <input type="email" value={email} onChange={(e) => this.setState({ email: e.target.value })} placeholder="Email Address" />
        <input type="password" value={password} onChange={(e) => this.setState({ password: e.target.value })} placeholder="Password" />
        <input type="password" value={password1} onChange={(e) => this.setState({ password1: e.target.value })} placeholder="Confirm Password" />

        {
          /*<label for="perms"><span style={{marginRight: '3px'}}>Enable Permissions</span>
                <input
                  id="perms"
                  type="checkbox"
                  checked={add_default}
                  onChange={e=>this.setState({ add_default: e.target.checked })}
                  placeholder='Use all permissions ?'/>
                </label>*/}

        <Button onClick={() => this.createUser()} primary>Submit</Button>
        <Link className='button view-users' to="/client-users">
          View Users
        </Link>
      </Page>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    profile: getProfile(state),
    authState: getAuthState(state),
    users: getUsers(state),
    isFetching: isFetching(state)

  }
}

export default connect(mapStateToProps,
  {
    fetchUsers,
    addUser,
    setPageTitle,
    notifSend
  },
)(ClientUserCreatePage);



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./src/containers/ClientUserCreatePage/index.js